<ng-template #headerTemplate>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/dashboard" (click)="dismissModal()"></ion-back-button>
      </ion-buttons>
      <ion-title>Informationen</ion-title>
    </ion-toolbar>
  </ion-header>
</ng-template>

  <ion-grid>
    <ion-row>
      <ion-col>
        <p>Version:</p>
        <p>{{'LABEL.IPADR' | translate}}</p>
        <p>{{'LABEL.HWID' | translate}}</p>
        <p>{{'LABEL.LICENSENUMBER' | translate}}</p>
        <p>{{'LABEL.SERIALNUMBER' | translate}}</p>
      </ion-col>
      <ion-col>
        @if (appVersionNumber) {
          <p>{{appVersionNumber}}</p>
        } @else {
          <p>2.4.0</p>
        }
        <p>{{IPADRESS()}}</p>
        <p>{{hwid()}}</p>
        <p>{{licenseNumber()}}</p>
        <p>{{serialNumber()}}</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p>{{'LABEL.THERMAL_STATUS' | translate}}</p>
        <p>{{'LABEL.CPU_TEMP' | translate}}</p>
      </ion-col>
      <ion-col>
        <p>
          @if (thermalLoading()) {
            <ion-spinner name="dots"></ion-spinner>
          } @else {
            {{ thermal()?.thermalStatusLabel || 'N/A' }}
            @if (thermal() && thermal().thermalStatus > 0) {
              <span>({{ thermal().thermalStatus }})</span>
            }
          }
        </p>
        <p>
          @if (thermalLoading()) {
            <ion-spinner name="dots"></ion-spinner>
          } @else {
            {{ maxCpuTemp() != null ? (maxCpuTemp() + ' °C') : 'N/A' }}
          }
        </p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <p>{{'LABEL.PEAK_CPU_TEMP' | translate}}</p>
        <p>{{'LABEL.MIN_CPU_TEMP' | translate}}</p>
        <p>{{'LABEL.WORST_THERMAL_STATUS' | translate}}</p>
        <p>{{'LABEL.TRACKING_SINCE' | translate}}</p>
      </ion-col>
      <ion-col>
        <p>
          @if (thermalLoading()) {
            <ion-spinner name="dots"></ion-spinner>
          } @else {
            @if (peaks()?.peakCpuTemp != null) {
              {{ peaks().peakCpuTemp | number:'1.0-1' }} °C
              <span>({{ peaks().peakCpuTempAt | date:'dd.MM HH:mm' }})</span>
            } @else {
              N/A
            }
          }
        </p>
        <p>
          @if (thermalLoading()) {
            <ion-spinner name="dots"></ion-spinner>
          } @else {
            @if (peaks()?.minCpuTemp != null) {
              {{ peaks().minCpuTemp | number:'1.0-1' }} °C
              <span>({{ peaks().minCpuTempAt | date:'dd.MM HH:mm' }})</span>
            } @else {
              N/A
            }
          }
        </p>
        <p>
          @if (thermalLoading()) {
            <ion-spinner name="dots"></ion-spinner>
          } @else {
            @if (peaks()?.worstThermalStatusLabel) {
              {{ peaks().worstThermalStatusLabel }}
              <span>({{ peaks().worstThermalStatusAt | date:'dd.MM HH:mm' }})</span>
            } @else {
              N/A
            }
          }
        </p>
        <p>
          @if (thermalLoading()) {
            <ion-spinner name="dots"></ion-spinner>
          } @else {
            {{ peaks()?.trackingSince ? (peaks().trackingSince | date:'dd.MM HH:mm') : 'N/A' }}
          }
        </p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="6">
        <ion-button size="small" fill="outline" (click)="resetThermalPeaks()">
          {{'BTN.RESET_THERMAL_PEAKS' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="6">
        <app-language-switcher class="ion-margin-top"></app-language-switcher>
      </ion-col>
    </ion-row>
  </ion-grid>

<ng-template #footerTemplate>
  <ion-row class="ion-text-center">
    <ion-col (click)="openBrowser('https://hxa.io/impressum/')">
      <p>{{'INFO_VIEW.IMPRINT' | translate}}</p>
    </ion-col>
    <ion-col (click)="openBrowser('https://hxa.io/privacy/')">
      <p>{{'BTN.DATAPRIVACY' | translate}}</p>
    </ion-col>
    <ion-col (click)="openBrowser('https://hxa.io/support/')">
      <p>Support</p>
    </ion-col>
  </ion-row>
</ng-template>